import React from "react";
import EventsCard from "../card/EventsCard";
import { useSelector } from "react-redux";
import SidebarFilter from "../landingPage/SidebarFilter";
import SearchBar from "../landingPage/SearchBar";
import TopEvents from "./components/TopEvents";
import Nodata from "../Nodata";
import { EventCardSkeleton } from "../skeleton/Skeleton";

const Events = () => {
  const { eventManagement } = useSelector((state) => state);

  return (
    <div className="flex pb-8">
      <SidebarFilter />
      <main className="flex-1 px-6 pb-6 pt-10 lg:h-[calc(100vh-130px)] overflow-y-auto">
        <SearchBar />
        {eventManagement?.isFetching ? (
          <div className="grid sm:grid-cols-2 2xl:grid-cols-4 gap-4 dark:bg-[#121415]">
            {[1, 2, 3, 4]?.map((el) => (
              <EventCardSkeleton key={el} />
            ))}
          </div>
        ) : (
          <>
            {eventManagement?.all?.data?.filter?.((el) => el?.class === "top")
              ?.length > 0 && <TopEvents />}
            <div class="flex items-center space-x-4 mt-5">
              <h2 class="text-sm font-bold text-gray-200 uppercase">
                Active <span class="dark:text-primary">Events</span>
              </h2>
              <div class="flex-grow border-t border-gray-700"></div>
            </div>
            <div className="mt-6">
              {eventManagement?.all?.data?.length > 0 ? (
                <div className="grid sm:grid-cols-2 2xl:grid-cols-4 gap-4 dark:bg-[#121415]">
                  {eventManagement?.all?.data
                    ?.filter?.((el) => el?.class === "middle")
                    ?.map((event, index) => (
                      <EventsCard key={index} event={event} />
                    ))}
                </div>
              ) : (
                <Nodata />
              )}
            </div>
          </>
        )}
      </main>
    </div>
  );
};

export default Events;
